// extracted by mini-css-extract-plugin
module.exports = {"container":"_3r2j5kRbZFCem3WDM1dz0T"};